import React, { useState, createContext, useContext } from 'react';

interface LoginBannerContext {
  showBanner: boolean;
  setShowBanner: (value: boolean) => void;
}

const initialBannerData: LoginBannerContext = {
  showBanner: false,
  setShowBanner: (value) => {}
};

export const LoginBannerContext = createContext<LoginBannerContext>(initialBannerData);

export const LoginBannerProvider = ({ children }: { children: React.ReactNode }) => {
  const [showBanner, setShowBanner] = useState<boolean>(false);
  return <LoginBannerContext.Provider value={{ showBanner, setShowBanner }}>{children}</LoginBannerContext.Provider>;
};

export const useBannerContext = (): LoginBannerContext => {
  return useContext(LoginBannerContext);
};
